import React from "react";

import PrismicImgix from "@sendmagic/prismic-nextjs/src/components/Imgix";
import PrismicLinkTag from "@sendmagic/prismic-nextjs/src/components/LinkTag";

import { textResolver } from "@sendmagic/prismic-nextjs/src/constants/text-resolver";
import { checkContentPresence } from "@sendmagic/prismic-nextjs/src/helpers/prismic";

const CTALink = ({ cta_text, cta_link }) =>
  checkContentPresence(cta_text) ? (
    <div className="text-center usecase-features-buttons-row">
      <PrismicLinkTag
        urlText={cta_text}
        url={cta_link?.url}
        target={cta_link?.target}
        className="font-weight-bold"
      />
    </div>
  ) : (
    <></>
  );

const FeaturesSmallIcons = ({ doc }) => {
  const {
    heading,
    sub_heading,
    internal_link_id,
    cta_text,
    cta_link,
    background_color,
    vertical_listing,
  } = doc?.primary || {};
  const brownBottomBorder = doc?.slice_label === "brown_bottom_border";
  const containerStyle = { backgroundColor: background_color };
  const customClass =
    checkContentPresence(heading) || checkContentPresence(sub_heading) ? "pt-5" : "pt-1";
  const verticalClass = vertical_listing
    ? "d-block d-md-flex vertical-container container-width mx-auto align-items-center"
    : "bg-white ";
  return (
    <div
      className={`${
        vertical_listing ? "vertical-listing-container w-100" : "container-width"
      } pt-md-5 pt-2xl-5 pt-4 pb-md-5 pb-2xl-5 px-md-5 px-2xl-5 pb-4 usecase-features-section prismic-slice`}
      style={containerStyle}
    >
      <div className={` ${customClass} pb-0 ${verticalClass}`}>
        <div className="vertical_listing-div">
          <div className="vertical_listing-width">
            {internal_link_id && (
              <span id={internal_link_id} className="scroll-point position-relative d-block" />
            )}
            {checkContentPresence(heading) && (
              <div className="sns-h2 text-theme-primary usecase-features-title same-size-title text-center">
                {textResolver(heading)}
              </div>
            )}
            {checkContentPresence(sub_heading) && (
              <div className="mt-4 mt-2xl-4 mx-auto sns-h5 text-center usecase-description-block">
                {textResolver(sub_heading)}
              </div>
            )}
            {vertical_listing && <CTALink cta_link={cta_link} cta_text={cta_text} />}
          </div>
        </div>
        <div className="pt-md-3 pt-2xl-3 pt-0 mt-5 mt-2xl-5 d-flex flex-wrap justify-content-center usecase-features-row vertical_listing-div vertical-listing-right-section">
          {doc?.items?.map(
            (
              {
                image,
                heading,
                text,
                strikethrough_text,
                highlighted_text,
                link: { url, target },
                cta_link_text,
              },
              idx
            ) => (
              <div
                className="mb-md-5 mb-2xl-5 mb-4 px-1 px-lg-2 px-2xl-2 position-relative text-center usecase-features-block d-flex flex-column"
                key={`option-${idx}`}
              >
                {image?.url && (
                  <div className="usecase-features-icon-block mx-auto">
                    <PrismicImgix
                      alt={image?.alt}
                      src={image?.url}
                      className="img-responsive img-responsive-height"
                      desktop="100px"
                      mobile="180px"
                      tablet="90px"
                      largeDisplay="200px"
                    />
                  </div>
                )}
                <div className="usecase-features-icon-text-block">
                  {checkContentPresence(heading) && (
                    <div
                      className={` font-weight-bold sns-h5 usecase-feature-head text-theme-primary mt-3 mt-2xl-3  ${
                        url ? "usecase-features-heading-block" : ""
                      } `}
                    >
                      {textResolver(heading)}
                    </div>
                  )}
                  {checkContentPresence(text) && (
                    <div className="mt-1 mt-2xl-1 sns-h5 usecase-feature-para usecase-features-text-block mb-3">
                      {textResolver(text)}
                    </div>
                  )}
                  <div className="mt-auto w-100">
                    {checkContentPresence(strikethrough_text) && (
                      <div className="mt-1 mt-2xl-1 sns-h5 usecase-features-text-block text-a1 font-weight-bold">
                        <s>{textResolver(strikethrough_text)}</s>
                      </div>
                    )}
                    {checkContentPresence(highlighted_text) && (
                      <div className="mt-1 mt-2xl-1 sns-h5 usecase-features-text-block navy-blue font-weight-bold">
                        {textResolver(highlighted_text)}
                      </div>
                    )}
                  </div>
                  {url && (
                    <PrismicLinkTag url={url} target={target} className="feature-block-link" />
                  )}
                  {checkContentPresence(cta_link_text) && (
                    <div className="usecase-features-text-block feature-cta-link-text lh-1 pb-2 text-uppercase font-weight-bold">
                      {textResolver(cta_link_text)}
                    </div>
                  )}
                </div>
              </div>
            )
          )}
        </div>
        {!vertical_listing && <CTALink cta_link={cta_link} cta_text={cta_text} />}
        {brownBottomBorder && <div className="brown-bottom-border d-none d-md-block" />}
      </div>
    </div>
  );
};

export default FeaturesSmallIcons;
